import { compile } from "vue";
export default {
    props: {
        html: {
            type: String,
            default: ""
        }
    },
    setup(props) {
        return compile(props.html);
    }
};
/*
 * To work; components used with this html render component need to be globally registered with the app.
 * Also vue.config.js => `runtimeCompiler: true` prop is required to have access to 'compile'.
 *
 * PS:
 * A potential workaround (TBD) could be to post-process registering components using regular expressions and filenames if global definitions yield too much overhead.
 */
